import { useGetOne } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import type { Vendor } from '../../types';

export const AutoPopulateVendorDetails = () => {
    const vendorId = useWatch({ name: 'vendor_id' });
    const { setValue } = useFormContext();

    const { data: vendor, isFetching } = useGetOne<Vendor>('vendors', { id: vendorId }, { enabled: !!vendorId });

    useEffect(() => {
        if (vendor && !isFetching) {
            // Auto-populate vendor contact details
            setValue('vendor_name', vendor.name || '', { shouldDirty: true });
            setValue('vendor_contact_person', vendor.contact_person || vendor.name, { shouldDirty: true });
            setValue('vendor_contact_no', vendor.phone || vendor.email || '', { shouldDirty: true });
            setValue('vendor_state', vendor.state || '', { shouldDirty: true });
            
            // Note: If using `vnd_code` in the form, populate it too
            if (vendor.code) {
                setValue('vnd_code', vendor.code, { shouldDirty: true });
            }
        }
    }, [vendor, isFetching, setValue]);

    return null;
};
